function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef } from 'react';
import { TextInput as PaperTextInput } from 'react-native-paper';
import { useHasError } from "../../hooks/useHasError.js";
import { Container } from "../Container/index.js";
export let TextInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    showErrorOnMount,
    autoFocus,
    input: {
      onChange,
      onFocus,
      onBlur,
      value
    },
    meta,
    label,
    secureTextEntry,
    style,
    getHelperText,
    ContainerProps,
    HelperTextProps
  } = _ref,
      InputProps = _objectWithoutProperties(_ref.input, ["onChange", "onFocus", "onBlur", "value"]),
      TextInputProps = _objectWithoutProperties(_ref, ["showErrorOnMount", "autoFocus", "input", "meta", "label", "secureTextEntry", "style", "getHelperText", "ContainerProps", "HelperTextProps"]);

  let textInputRef = useRef(ref);
  let error = useHasError(meta, showErrorOnMount);
  let helperText = getHelperText(error && meta.error);
  useEffect(() => {
    if (secureTextEntry && style && style.hasOwnProperty("fontFamily")) {
      var _textInputRef$current, _textInputRef$current2;

      textInputRef === null || textInputRef === void 0 ? void 0 : (_textInputRef$current = textInputRef.current) === null || _textInputRef$current === void 0 ? void 0 : (_textInputRef$current2 = _textInputRef$current.setNativeProps) === null || _textInputRef$current2 === void 0 ? void 0 : _textInputRef$current2.call(_textInputRef$current, {
        style: {
          fontFamily: style.fontFamily
        }
      });
    }
  }, [secureTextEntry]);
  useEffect(() => {
    if (autoFocus) {
      var _textInputRef$current3, _textInputRef$current4;

      textInputRef === null || textInputRef === void 0 ? void 0 : (_textInputRef$current3 = textInputRef.current) === null || _textInputRef$current3 === void 0 ? void 0 : (_textInputRef$current4 = _textInputRef$current3.focus) === null || _textInputRef$current4 === void 0 ? void 0 : _textInputRef$current4.call(_textInputRef$current3);
    }
  }, [autoFocus]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, ContainerProps, {
    HelperTextProps: _objectSpread(_objectSpread({}, HelperTextProps), {}, {
      children: helperText,
      visible: !!helperText,
      type: error ? 'error' : 'info'
    })
  }), /*#__PURE__*/React.createElement(PaperTextInput, _extends({}, InputProps, TextInputProps, {
    label: label,
    style: style,
    secureTextEntry: secureTextEntry,
    ref: textInputRef,
    value: value,
    error: error,
    onChangeText: onChange,
    onBlur: event => onBlur(event),
    onFocus: event => onFocus(event)
  })));
});
TextInput.displayName = 'TextInput';
TextInput.defaultProps = {
  showErrorOnMount: false,
  autoFocus: false,
  getHelperText: str => str,
  style: {},
  ContainerProps: {},
  HelperTextProps: {
    padding: 'normal'
  }
};